import OffersListings from "../../../Components/Pricings/Offers/OffersListings";

export default function OfferListing() {
    return (
        <OffersListings />
    )
}